import{a as m}from"./chunk-BZVHZRTX.js";import{a as e}from"./chunk-LWM7TK5F.js";import{n as o,o as r}from"./chunk-3QROWZCZ.js";var i=new o({locale:[m,e,r]});export{i as a};
